<script>
    import Mobilebtn2 from '../../reusableitems/twoinoneMobile.svelte';
    import MobileNavbar1 from '../../reusableitems/mobileNavbar1.svelte';
    let flag = false;
    export const call = false;
    import {fly} from 'svelte/transition';
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    import AlphabetAnimation from '../../reusableitems/homepagewordsanimation/wordsanimation.svelte';
    const menulist = [
        {Menu: 'Dreamers'},
        {Menu: 'Gamers'},
        {Menu: 'Artists'},
        {Menu: 'Storytellers'},
        {Menu: 'Musicians'},
        {Menu: 'Advertisers'},
        {Menu: 'Investors'},
        {Menu: ' & Technical Creators'},
    ];
    let scrollY;
    let state1;
    let state2;
    let menu;
    // export let navbarPosition = false;
    $: {
        if (scrollY > 10) {
            state1.style.opacity = '0%';
            state2.style.top = '0vw';
            state2.style.opacity = '100%';
            state1.style.zIndex = '0';
            state2.style.zIndex = '3';
            menu.style.bottom='15vw';
            flag = true;
        } else if (scrollY < 10 && flag === true) {
            state2.style.opacity = '0%';
            menu.style.bottom='-50vw';
            state2.style.top = '29vw';
            state1.style.opacity = '100%';
            state2.style.zIndex = '0';
            state1.style.zIndex = '1';
        }
    }
    let navbarOpacity;
    let nav;
    // let mainDivPosition = 'none';
    // $: {
    //     if (navbarOpacity = '1') {
    //         navbarPosition = true;
    //     } else if (navbarOpacity = '0') {
    //         navbarPosition = false;
    //     }
    // }
    export let getSession;
    // getSession = 'hello';
</script>

<svelte:window bind:scrollY />
<div class="mainDiv" >
   
    <div style="opacity: 1; " bind:this={navbarOpacity}>
        <MobileNavbar1 bind:getSession/>
    </div>

    <div class="mobilescreen" bind:this={state1}  in:fly={{duration: 1000, y: 800}}>
        <div class="text-content">
            <div>
                <p>Our</p>
                <h1>TECHNOLOGY</h1>
                <p>turns text to</p>
            </div>
        </div>
        <div class="word-animation">
            <AlphabetAnimation/>
         </div>
        <div class="alphabetanimation" />
        <div class="imgwrraper">
            <div
                class="imgwrraper"
                on:click={() => {
                    state1.style.opacity = '0%';
                    state2.style.top = '0vw';
                    menu.style.bottom='15vw';
                    state2.style.opacity = '100%';
                    state1.style.zIndex = '0';
                    nav.style.opacity='1';
                    navbarOpacity.style.opacity='0';
                    state2.style.zIndex = '3';
                }}
                role="presentation"
            >
                <img
                    src="/images/men.png"
                    alt="img"
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="text">
                <p>
                    Let’s build the future of decentralized entertainment
                    together.
                </p>
            </div>

            <div class="demobutton" role="presentation" on:click={() => {
                goto('/demo');
            }}>
                <div class="playwrraper">
                    <img
                        src="/images/playButton.svg"
                        alt="play"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="watchButton" >
                    <p>Watch Demo</p>
                </div>
            </div>
        </div>
    </div>
    <div
        class="mobilescreen2"
        role="presentation"
        bind:this={state2}
    >
    <div class="navbar" bind:this={nav} >
        <MobileNavbar />
    </div>
    <div  role="presentation"
    
    on:click = {() => {
        // state2.style.opacity = '0%';
        // state2.style.top = '29vw';
        // menu.style.bottom='-50vw';
        // state1.style.opacity = '100%';
        // state2.style.zIndex = '0';
        // state1.style.zIndex = '1';
        // nav.style.opacity='0';
        // navbarOpacity.style.opacity='1';
    }}>
        <div class="textSecondIterration">
            <h6>
                We are a self sustaining decentralized global community of ....
            </h6>
        </div>
        <div class="textButton" bind:this={menu}>
            <div class="menulist">
                {#each menulist as data}
                    <h1>
                        {data.Menu}
                    </h1>
                {/each}
            </div>
            <div class="joinbutton">
                <Mobilebtn2 />
            </div>
        </div>
    </div>
    <div class="swipe">
        <p>Swipe up to continue.</p>
    </div>
</div>
</div>

<style>
    /* .textButton {
        position: absolute;
        left: 5vw;
        bottom: 15vw;
    } */
    .word-animation{
        display: flex;
        justify-content: center;
        height: 8.645vw;
    }
    .mainDiv {
        position: relative;
        font-family: "Orbitron";
        height: max(216vw,100vh);
        width: 100vw;
        box-sizing: border-box;
    }
    
    .mobilescreen {
        bottom: 0;
        width: 100vw;
        padding: 10vw;
        height: 187.15vw;
        position: absolute;
        box-sizing: border-box;
        border-radius: 14.019vw 14.019vw 0 0;
        background-color: rgb(0, 0, 0, 1);
        /* display: none; */
        opacity: 100%;
        transition-duration: 1s;
        z-index: 1;
    }
    .text-content {
        font-family: "Orbitron";
        width: 84.813vw;
        margin: auto;
        color: #ffffff;
    }
    .text-content,
    p,
    h1 {
        margin: 0 auto;
        text-transform: uppercase;
    }
    .text-content p {
        font-weight: 900;
        font-size: 3.738vw;
        line-height: 4.673vw;
    }
    .text-content p:nth-child(1) {
        margin-left: 12vw;
    }
    .text-content p:nth-child(3) {
        margin-left: 40.5vw;
    }
    .text-content h1 {
        color: black;
        font-weight: 900;
        text-align: center;
        font-size: 7.009vw;
        line-height: 8.879vw;
        letter-spacing: 0.06em;
        -webkit-text-stroke: 0.234vw white;
    }
    .alphabetanimation {
        height: 8.645vw;
        width: 100%;
    }
    .imgwrraper {
        width: 80.374vw;
        height: 73.131vw;
        margin: auto;
    }
    .text {
        color: white;
        width: 84.813vw;
        text-align: center;
        margin: auto;
        margin-top: 12vw;
    }
    .text p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        letter-spacing: 0.06em;
        color: #ffffff;
        text-transform: none;
    }
    .demobutton {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8vw;
        position: relative;
    }
    .playwrraper {
        width: 7.009vw;
        height: 7.009vw;
    }
    .watchButton p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 500;
        font-size: 2.336vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #ffffff;
        padding-left: 5vw;
    }
    .watchButton p::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 14.5vw;
        border-bottom: 0.5vw solid white;
        left: 36vw;
    }
    .mobilescreen2 {
        padding: 5vw;
        width: 100vw;
        height: 187.15vw;
        top: 29vw;
        overflow: inherit;
        position: absolute;
        box-sizing: border-box;
        font-family: "Orbitron";
        background-color: #000000;
        border-radius: 0 0 14.019vw 14.019vw;
        opacity: 0%;
        transition-duration: 0.8s;
        z-index: 0;
    }
    .swipe p {
        font-family: "Orbitron";
        font-weight: 400;
        font-size: 2.336vw;
        line-height: 3.037vw;
        letter-spacing: 0.06em;
        color: #000000;
        position: absolute;
        bottom: 10vw;
        left: 32vw;
    }
    .textSecondIterration {
        position: absolute;
        top: 28vw;
        left: 15vw;
        z-index: 1;
        /* opacity: 0%; */
        width: 70vw;
    }
    .textSecondIterration h6 {
        font-weight: 400;
        font-size: 4.673vw;
        line-height: 140%;
        text-align: center;
        letter-spacing: 0.06em;
        color: #ffffff;
    }
    .textButton {
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        bottom: -50vw;
        transition-duration: 1.5s;
    }
    .menulist h1 {
        font-weight: 900;
        font-size: 5.607vw;
        line-height: 140%;
        font-style: normal;
        text-align: center;
        letter-spacing: 0.06em;
        background: linear-gradient(90deg, #9796f0 0%, #fbc7d4 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
    .joinbutton {
        padding-left: 19.86vw;
        margin: 15vw auto;
    }
    .navbar {
        transition-duration: 1s;
        opacity: 0;
        position: absolute;
        width: 100%;
        height: fit-content;
        z-index: 101;
        animation: slideup 1.6s forwards;
        left: 0;
        top: 0;
    }
    @keyframes slideup{
        0%{
            transform: translateY(100vw);
            opacity: 0;
        }
        100%{
            transform: translateY(0vw); 
            opacity: 1;
        } 
    }
    .navbar {
        position: fixed;
        width: 100%;
        height: fit-content;
        z-index: 100;
        animation: slideup 1s forwards;
        animation: opacity 1s forwards;
    }
    @keyframes slideup{
        0%{
            transform: translateY(40vw);
            /* opacity: 0; */
        }
        100%{
            transform: translateY(0vw);
            /* opacity: 1; */
        }
    }
        @keyframes opacity{
        0%{
            /* transform: translateY(40vw); */
            opacity: 0;
        }
        100%{
            /* transform: translateY(0vw); */
            opacity: 1;
        }
        }
</style>
